var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"mb-16"},[_c('v-col',{attrs:{"cols":"12","sm":"12"}},[_c('h1',{staticClass:"text-left",attrs:{"left":""}},[_vm._v("Serch Bar here")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }